import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function SkipReservedStepField(props) {
    return (
        <FormikInput
            type={'checkbox'}
            name={'skipReservedStep'}
            label={'shippingMethods.form.field.skipReservedStep.label'}
            noPadding={true}
        />
    )
}

export default SkipReservedStepField;
